export default __webpack_public_path__ + "static/brownBack-03b5e44024ed2462cd68a41264d5aa14.jpg";